import { Container, Box, Typography, Grid, Divider } from "@mui/material";

import ChinesePoker from "./../../assets/images/game/AMBP_Chinese Poker 6 Cards Legend of Dragon_1694777558.webp"
import Teekai3Card from "./../../assets/images/game/AMBP_Teekai 3 Card Pattaya_1694777822.webp"
import Teekai2Card from "./../../assets/images/game/AMBP_Teekai 2 Cards Night Club_1695386626.webp"
import HiloLegend from "./../../assets/images/game/AMBP_Hilo Legend_1695385974.webp"
import PokdengTwo from "./../../assets/images/game/AMBP_Pok Deng 2_1657094031.webp"
import Pokdeng from "./../../assets/images/game/AMBP_POKDENG_1622702829.webp"
import Paikang from "./../../assets/images/game/AMBP_PAI KANG_1622702957.webp"
import Baccarat from "./../../assets/images/game/AMBP_Baccarat_1622704214.webp"
import Hilo from "./../../assets/images/game/AMBP_HILO_1622702151.webp"
import Teekai2 from "./../../assets/images/game/AMBP_TK 2 Cards_1637830359.webp"
import DragonTiger from "./../../assets/images/game/AMBP_DragonTiger_1652178016.webp"
import PanPae from "./../../assets/images/game/AMBP_Head or Tail Arcade_1622704517.webp"
import TK3 from "./../../assets/images/game/AMBP_TK 3 Cards_1637830395.webp"
import BattleRoyal from "./../../assets/images/game/AMBP_BATTLEROYAL_1622702667.webp"
import Poker6Cards from "./../../assets/images/game/AMBP_Chinese Poker 6 Cards_1622703680.webp"
import NamTaoPuPa from "./../../assets/images/game/AMBP_NAMTAOPUPA_1622702061.webp"
import DartFest from "./../../assets/images/game/AMBP_Dart Fest_1650970090.webp"
import Hopeful from "./../../assets/images/game/AMBP_Ring of Hopeful_1650975266.webp"
import ScoopeBlessing from "./../../assets/images/game/AMBP_Scoop blessing_1650975287.webp"

const GameList = [
    {
        name: 'Chinese Poker 6 Cards Legend of Dragon',
        img: ChinesePoker
    },
    {
        name: 'Teekai 3 Card Pattaya',
        img: Teekai3Card
    },
    {
        name: 'Teekai 2 Cards Night Club',
        img: Teekai2Card
    },
    {
        name: 'Hilo Legend',
        img: HiloLegend
    },
    {
        name: 'Pok Deng 2',
        img: PokdengTwo
    },
    {
        name: 'ป๊อกเด้ง',
        img: Pokdeng
    },
    {
        name: 'ไพ่แคง',
        img: Paikang
    },
    {
        name: 'บาคาร่า',
        img: Baccarat
    },
    {
        name: 'ไฮโล',
        img: Hilo
    },
    {
        name: 'ตีไก่ 2 ใบ',
        img: Teekai2
    },
    {
        name: 'มังกรสู้เสือ',
        img: DragonTiger
    },
    {
        name: 'ปั่นแปะอาร์เคด',
        img: PanPae
    },
    {
        name: 'ตีไก่ 3 ใบ',
        img: TK3
    },
    {
        name: 'เป่ายิ้งฉุบ',
        img: BattleRoyal
    },
    {
        name: 'ไพ่สามกอง 6 ใบ',
        img: Poker6Cards
    },
    {
        name: 'น้ำเต้าปูปลา',
        img: NamTaoPuPa
    },
    {
        name: 'Dart Fest',
        img: DartFest
    },
    {
        name: 'Ring of Hopeful',
        img: Hopeful
    },
    {
        name: 'Scoop blessing',
        img: ScoopeBlessing
    }
]

const Game = () => {
    return (
        <Container>
            <Box width={`100%`} className="card-header-bg">
                <Typography display={`flex`} justifyContent={`center`} fontSize={24} color={`white`} py={1}>
                    เกมส์
                </Typography>
            </Box>
            <Box sx={
                {
                    backgroundColor: 'rgba(0, 0, 0, 0.309)',
                    textAlign: 'center'
                }
            }>
                <Grid container>
                    <Grid item xs={12} py={2}>
                        <Typography fontSize={20} color={`white`} lineHeight={1}>
                            โปกเกอร์ ป๊อกเด้ง ไพ่แคง ไฮไล ไพ่สามกอง เกมส์ไพ่
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Box className="line"></Box>
                    </Grid>
                    <Grid item xs={12} my={2}>
                        <Typography fontSize={19} color={`white`} lineHeight={1} px={1}>
                            ป็อกเด้งออนไลน์ เกมส์ไพ่ยอดนิยม เล่นได้เงินจริง รวมเกมส์ไพ่ โป๊กเกอร์(poker) ไพ่แคง ป็อกเด้ง
                        </Typography>
                    </Grid>
                    <Grid item xs={12} mb={2}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} pb={3} pt={1} px={1}>
                        <Grid container spacing={.5} display={`flex`} justifyContent={`center`}>
                            {
                                GameList.map((item, index) => {
                                    return (
                                        <Grid item xs={4} sm={2} md={2} lg={2} key={index} sx={{ cursor: 'pointer' }}>
                                            <img src={item.img} alt="" style={{ width: `100%` }} />
                                            <Typography lineHeight={1} fontSize={16} color={`white`}>
                                                {item.name}
                                            </Typography>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Box className="line"></Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography px={3} color={`white`} fontSize={16}>
                            AMBPOKER พร้อมรับความสนุกกับเกมส์คาสิโนออนไลน์รูปแบบใหม่ ภาพสวย สีสันงดงามท่านจะพบกับเกมพนันรูปแบบใหม่ เกมไพ่นาๆชนิด ไม่ว่าจะเป็น ไพ่แคง ป๊อกเด้ง เกมไพ่ที่ทุกๆคนรู้จักกันดี หรือจะเป็น ตีไก่สองใบ , ตีไก่สามใบ เกมนี้ถ้ามือขึ้นรับรองรวยแน่นอน ถ้ายังไม่จุใจ อยากจัดไพ่เล่นเพลินๆต้องนี้เลย เกม ไพ่สามกอง เกมส์คาสิโนออนไลน์ของ ambpoker นั้นไม่ใช้เล่นกับ บอท แต่นี้เป็นเกมที่ผู้เล่นสามารถเล่นด้วยกันจริงๆ ไม่เพียงเป็นแค่ผู้เล่น ผู้เล่นนั้นสามารถเป็นเจ้ามือเองก็ได้ด้วย เป็นไงละ ไม่มีเว็บไหนที่เหมือนกับที่นี้อีกแล้วเฉพาะที่เดียว ambpoker1234 เท่านั้น ถ้าอิ่มอกอิ่มใจกับพวกเกมส์ไพ่ แล้วทางเราก็มี ไฮโล , ปั่นแปะ , น้ำเต้าปูปลา หรือแม้แต่เป่ายิงฉุบ มาเลยวันนี้ สมัครคาสิโนออนไลน์ เกมไพ่ป๊อกเด้ง สามกองหกใบ กับเราเล่นวันนี้รับไปเลน เครดิตฟรี ฟรีเครดิต มาทางนี้จบที่เดียวหรือ เกมส์ไพ่ออนไลน์ ก็พร้อมมีให้ท่านได้ร่วมสนุก อยากจะเป็นเจ้ามือเอง หรือ ผู้รวมวง ก็มาลุ้นรวย ลุ้นเงินรางวันได้ ทุกวัน อย่ารอช้าโอกาสดีๆ เพียงแค่สมัครป๊อกเด้ง ออนไลน์กับเราวันนี้ รับไปเลย เครดิตฟรี เล่นเกมไหนไม่เป็น หรือ อยากเป็นเจ้า แต่มไม่รู้ทำยังไง เกมส์ของเรานั้นมีคู่มือการเล่นให้ทุกเกม หรือถ้าไม่เข้าใจก็สามารถ ติดต่อกับทีมงาน ได้ตลอดทุกเวลา ฝากถอน ออโต้ ใช้เวลาเพียงไม่กี่วินาที มาเลยวันนี้ รับรอง รวย แน่นอน อย่ารอช้า นึกถึง ป๊อกเด้ง เกมไพ่ มันส์ๆ ต้อง AMBPOKER1234 เท่านั้น
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    )
}

export default Game;